import { createSlice } from "@reduxjs/toolkit";

const savedLocation = JSON.parse(localStorage.getItem("user_location"));

const initialState = {
  lat: savedLocation?.lat || null,
  lng: savedLocation?.lng || null,
  status: savedLocation ? "success" : "idle",
  error: null,
};

const locationSlice = createSlice({
  name: "location",
  initialState,
  reducers: {
    locationRequest: (state) => {
      state.status = "loading";
      state.error = null;
    },

    locationSuccess: (state, action) => {
      state.lat = action.payload.lat;
      state.lng = action.payload.lng;
      state.status = "success";

      // 🔐 localStorage persist
      localStorage.setItem(
        "user_location",
        JSON.stringify(action.payload)
      );
    },

    locationFailure: (state, action) => {
      state.status = "error";
      state.error = action.payload;
    },

    resetLocation: (state) => {
      localStorage.removeItem("user_location");
      return {
        lat: null,
        lng: null,
        status: "idle",
        error: null,
      };
    },
  },
});

export const {
  locationRequest,
  locationSuccess,
  locationFailure,
  resetLocation,
} = locationSlice.actions;

export default locationSlice.reducer;
